import React from 'react';
import { motion } from 'framer-motion';
import { MapPin } from 'lucide-react';
export function LocationSection() {
  return <section id="location" className="py-20 bg-white" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <span className="text-[#C1694F] font-medium tracking-wider uppercase text-sm mb-2 block" data-id="element-125">
            The Setting
          </span>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2D2D2D]" data-id="element-126">
            Desert Hills Foothills
          </h2>
        </div>

        <div className="relative rounded-2xl overflow-hidden shadow-lg h-[400px] md:h-[500px]" data-id="element-127">
          {/* Background Image */}
          <img src="https://cdn.magicpatterns.com/uploads/n1vZroareFjtJNXpsBRa1j/Screenshot_2026-01-19_at_11.55.21_AM.png" alt="Desert Hills trail with mountain views" className="w-full h-full object-cover" data-id="element-128" />
          <div className="absolute inset-0 bg-black/30 flex items-center justify-center" data-id="element-129">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-white/95 backdrop-blur-md p-8 rounded-lg max-w-lg mx-4 text-center shadow-2xl" data-id="element-130">
              <MapPin className="w-10 h-10 text-[#C1694F] mx-auto mb-4" data-id="element-131" />
              <h3 className="text-2xl font-serif font-bold mb-4" data-id="element-132">
                Connected Seclusion
              </h3>
              <p className="text-gray-600 mb-6" data-id="element-133">
                Located just 10 minutes from I-17, you're close enough to the
                city for convenience but far enough to see the Milky Way at
                night.
              </p>
              <div className="grid grid-cols-2 gap-4 text-sm text-left" data-id="element-134">
                <div className="flex items-center text-gray-700" data-id="element-135">
                  <span className="w-1.5 h-1.5 bg-[#C1694F] rounded-full mr-2" data-id="element-136"></span>
                  15 min to Lake Pleasant
                </div>
                <div className="flex items-center text-gray-700" data-id="element-137">
                  <span className="w-1.5 h-1.5 bg-[#C1694F] rounded-full mr-2" data-id="element-138"></span>
                  10 min to Shopping
                </div>
                <div className="flex items-center text-gray-700" data-id="element-139">
                  <span className="w-1.5 h-1.5 bg-[#C1694F] rounded-full mr-2" data-id="element-140"></span>
                  35 min to Scottsdale
                </div>
                <div className="flex items-center text-gray-700" data-id="element-141">
                  <span className="w-1.5 h-1.5 bg-[#C1694F] rounded-full mr-2" data-id="element-142"></span>
                  40 min to Sky Harbor
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
}